import { ColumnDef } from '@tanstack/react-table';
import { DataRetentionRecordUI } from '../dataTypeMapping';
import { Button } from '@/components/ui/button';
import React from 'react';
import AssetsSuppliersCell from './AssetsSuppliersCell';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrash } from '@awesome.me/kit-269fbef2e2/icons/duotone/solid';

export function getDataRetentionColumns(onView: (record: DataRetentionRecordUI) => void, onDelete: (record: DataRetentionRecordUI) => void): ColumnDef<DataRetentionRecordUI, any>[] {
  return [
    {
      header: 'Type',
      accessorKey: 'dataTypeName',
      cell: ({ getValue }) => <span>{getValue()}</span>,
    },
    {
      header: 'Retention Period',
      accessorFn: row => ({ min: row.dataRetentionPeriodMin, max: row.dataRetentionPeriodMax, unit: row.dataRetentionPeriodUnit }),
      cell: ({ row }) => {
        const min = row.original.dataRetentionPeriodMin;
        const max = row.original.dataRetentionPeriodMax;
        const unit = row.original.dataRetentionPeriodUnit || 'years';
        // Clamp for bar rendering
        const minVal = Math.max(0, Math.min(100, min));
        const maxVal = Math.max(0, Math.min(100, max));
        return (
          <div className="flex flex-col items-stretch min-w-[120px]">
            <div className="flex justify-between text-xs text-muted-foreground mb-0.5">
              <span className="font-bold text-foreground">{unit === 'minutes' ? Math.round(min) : min} {unit}</span>
              <span className="font-bold text-foreground">{unit === 'minutes' ? Math.round(max) : max} {unit}</span>
            </div>
            <div className="relative h-2 rounded bg-muted overflow-hidden">
              <div
                className="absolute top-0 h-2 bg-primary/60 rounded"
                style={{ left: `${minVal}%`, width: `${Math.max(2, maxVal-minVal)}%` }}
              />
            </div>
          </div>
        );
      },
    },
    {
      header: 'Assets/Suppliers',
      accessorFn: row => row.assets,
      cell: ({ row }) => <AssetsSuppliersCell items={row.original.assets || []} />,
    },
    {
      header: 'Status',
      accessorKey: 'status',
      cell: ({ row }) => {
        // Status comes from the UI mapping (Active/Inactive)
        const status = row.original.status;
        return (
          <span style={{ color: status === 'Active' ? 'green' : 'gray', fontWeight: 500 }}>{status}</span>
        );
      },
    },
    {
      header: 'Actions',
      id: 'actions',
      cell: ({ row }) => (
        <div className="flex gap-1 justify-center">
          <Button variant="ghost" size="icon" onClick={(e) => {
            e.preventDefault();
            onView(row.original);
          }} title="View">
            <FontAwesomeIcon icon={faPencil} className="h-4 w-4" />
          </Button>
          <Button variant="ghost" size="icon" onClick={(e) => {
            e.preventDefault();
            onDelete(row.original);
          }} title="Delete" className="text-destructive hover:text-destructive">
            <FontAwesomeIcon icon={faTrash} className="h-4 w-4" />
          </Button>
        </div>
      ),
      enableSorting: false,
    },
  ];
}
